import * as React from "react";
import type { SVGProps } from "react";
const SvgMapPin = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M8 9.5c0 2.21 1.79 4 4 4s4-1.79 4-4-1.79-4-4-4-4 1.79-4 4m2 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.28 21.7c.19.19.45.3.72.3s.53-.11.72-.3c.74-.77 7.28-7.63 7.28-11.75C20 5.57 16.41 2 12 2S4 5.57 4 9.95c0 4.12 6.53 10.98 7.28 11.75M6 9.95C6 6.67 8.69 4 12 4s6 2.67 6 5.95c0 2.5-3.84 7.22-6 9.59-2.16-2.37-6-7.09-6-9.59"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMapPin;
